import React, { FC } from 'react';
import { DraggableComponentProps } from 'features/document/constants';
import { isRadioButtonElement } from 'utils/typeGuards';
import { Container, Radio, Wrapper } from './RadioButton.styled';

const RadioButton: FC<DraggableComponentProps> = ({ currentElement }) => {
  if (!isRadioButtonElement(currentElement)) {
    return null;
  }
  const { id } = currentElement;
  const { elements, groupDirection } = currentElement.content;

  return (
    <Container style={{ flexDirection: groupDirection === 'vertical' ? 'column' : 'row' }}>
      {elements.map((element, index) => (
        <Wrapper key={`radio-button-${id}-${index}`}>
          <Radio id={`${id}-${index}`} type='radio' />
          <label htmlFor={`${id}-${index}`}>{element}</label>
        </Wrapper>
      ))}
    </Container>
  );
};

export default RadioButton;
